module.exports = __webpack_public_path__ + "static/media/brujula-en.6027a2b3.svg";